export default "__VITE_ASSET__CSc_nXSB__"